<template>
  <div class="phone-login-container">
    <div class="phone-login-tip" :class="`${tipStatus}-tip`" v-if="tipStatus !== 'none'">
      <div>
        <span class="tip_text">{{ tipMessage }}</span>
      </div>
      <div @click="closeTip" class="cursor-pointer"></div>
    </div>
    <el-form
      ref="account"
      :model="entity"
      :rules="rules"
      hide-required-asterisk
    >
      <div class="phone-container">
        <el-form-item prop="mobilePhone">
          <el-input
            ref="mobilePhoneInput"
            v-model="entity.mobilePhone"
            @keyup.native.enter="focusInput('passwordInput')"
            placeholder="请输入手机号"
            maxlength="11"
            show-word-limit
            clearable
          >
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="code-container">
        <el-form-item prop="verificationCode">
          <el-input
            ref="codeInput"
            auto-complete="new-password"
            v-model="entity.verificationCode"
            @input="
              (value) => (entity.verificationCode = value.replace(/[^\d]/g, ''))
            "
            placeholder="请输入验证码"
            @keyup.native.enter="focusInput('submitBtn')"
            maxlength="6"
          ></el-input>
          <el-button
            class="code-button"
            @click="popupSlidingCaptcha()"
            :disabled="getCaptchaDisabled"
            stopCountDown
          >
            {{ codeMessage }}
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <Explain />
    <el-button
      class="submit-btn"
      ref="submitBtn"
      type="primary"
      size="long"
      :loading="loading"
      @keyup.native.enter="submitForm('account')"
      @click="submitForm('account')"
    >
      登录/注册
    </el-button>
  </div>
</template>

<script>
import { loginForMobile } from "@/api/home/login";
import CaptchaApi from "@/api/system/captchaApi";
import Explain from "./explain.vue";

export default {
  components: { Explain },
  data() {
    return {
      entity: {
        mobilePhone: "", // 用户名
        verificationCode: "", // 验证码
      },
      isRemember: false, // 记住账号
      codeMessage: "获取验证码", // 验证码提示
      rules: {
        mobilePhone: [
          { required: true, message: "请输入手机号！" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!/^1[3-9]\d{9}$/.test(value)) {
                callback("手机号格式不正确!");
              } else {
                callback();
              }
            },
          },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码!" },
          { len: 6, message: "验证码长度必须为6位!", trigger: "blur" },
        ],
      },
      tipStatus: "none", // 提示状态：none.消失 success.成功 fail.失败
      tipMessage: "", // 提示内容
      loading: false // 登录按钮加载状态
    };
  },
  computed: {
    // 获取验证码按钮-禁用状态
    getCaptchaDisabled() {
      return this.codeMessage !== "获取验证码";
    },
  },

  methods: {
    /**
     * @description: 聚焦到指定输入框
     * @param {String} name 注册的ref名称
     */
    focusInput(name) {
      if (name == "submitBtn") {
        this.$refs[name].click();
      } else {
        this.$refs[name].focus();
      }
    },

    /**
     * @description 关闭提示
     */
    closeTip() {
      this.tipStatus = "none";
    },

    /**
     * @description 弹出滑块验证
     */
    popupSlidingCaptcha() {
      this.$refs["account"].validateField("mobilePhone", (error) => {
        if (error) {
          this.$message.error(error);
        } else {
          this.closeTip();
          this.$emit("popup");
        }
      });
    },

    /**
     * @description 获取验证码
     */
    getVerificationCode(key) {
      let data = {
        mobilePhone: this.entity.mobilePhone,
        useType: "MOBILE_LOGIN",
        slidingCaptchaKey: key,
      };
      CaptchaApi.getPhoneCaptcha(data).then((res) => {
        if (res && res.code === "00000") {
          this.entity.verificationCode = "";
          this.tipMessage = "短信验证码已发送，可能会有延后，请耐心等待";
          this.tipStatus = "success";
          this.countDown(60);
        }
      });
    },

    /**
     * @description: 获取手机验证码后按钮变60秒倒计时
     */
    countDown(n) {
      this.codeMessage = n + "s后重试";
      setTimeout(() => {
        n--;
        if (n > 0) {
          this.countDown(n);
        } else {
          this.codeMessage = "获取验证码";
        }
      }, 1000);
    },

    /**
     * @description: 登录提交
     */
    submitForm(formName) {
      this.closeTip();
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        loginForMobile(this.entity).then((res) => {
          if (res?.model && res.model.accessToken && res.model.tokenType) {
            this.$emit("login-success", res.model.tokenType + res.model.accessToken);
          }
        }).finally(() => {
          this.loading = false;
        });
      });
    },
  },
};
</script>
<style scoped lang="less">
.phone-login-container {
  width: 100%;
  .phone-login-tip {
    width: 100%;
    height: 24px;
    display: flex;
    align-items: center;
    padding: 0 13px;
    margin-bottom: 5px;
    box-sizing: border-box;
    .tip_text {
      margin-left: 6px;
      font-size: 12px;
    }
  }
  .success-tip {
    background-color: #f0fff8;
    border: 1px solid #27d17e;
    .tip_text {
      color: #27d17e;
    }
  }
  .error-tip {
    background-color: #fff0f0;
    border: 1px solid #fc8080;
    .tip_text {
      color: #fc8080;
    }
  }

  .success-tip,
    .error-tip {
        & + .el-form {
            padding-top: 5px;
        }
  }

  // 表单
  .el-form {
    width: 100%;
    padding-top: 15px;
    .el-form-item {
      margin-bottom: 24px;
    }
    .phone-container {
      width: 100%;
      /deep/ .el-input-group__prepend {
        background-color: #fff;
        color: #1d2129;
      }
    }
    .code-container {
      :deep(.el-form-item__content) {
        display: flex;
        .el-input {
          flex: 1;
        }
        .code-button {
          width: 91px;
          height: 46px;
          text-align: center;
          background: #f6f8fa;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #dde2e9;
          margin-left: 9px;
          font-size: 14px;
          padding: 12px 0;
          color: #1D2129;
          &.is-disabled {
            background-color: #fafafa !important;
            color: #737373 !important;
          }
        }
      }
    }
  }

  // 按钮
  .el-button {
    &.el-button--long {
      width: 100%;
      height: 48px;
      font-size: 16px;
      font-family: @font-medium;
      border-radius: 4px;
      border: none;
      margin-top: 24px;
    }
    &.el-button--long,
    &.el-button--long:focus,
    &.el-button--long:hover {
      background: linear-gradient(90deg, #ff9b02 0%, #ff8100 100%);
    }
  }

  .el-input__inner {
    margin-left: 0;
  }
}
</style>
